import axios from 'axios';
import { VriAPIResponse, VriAPIResult } from '../types';
import { BusinessDisplayUnit } from '../types/business-group-type';
import END_POINT from '../config/endpoints.constants';
import { getErrorMessage } from '../customer-call-sdk/lib/API';

export interface GetAllBusinessDisplayUnitListRequestPayload {
    limit: number;
    offset: number;
}

export interface GetAllBusinessDisplayUnitListResult extends VriAPIResult {
    data?: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}

export interface GetAllBusinessDisplayUnitListResponse extends VriAPIResponse {
    data: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}

export const getAllBusinessDisplayUnitList = async (
    payLoad: GetAllBusinessDisplayUnitListRequestPayload,
): Promise<GetAllBusinessDisplayUnitListResult> => {
    const result = {} as GetAllBusinessDisplayUnitListResult;
    try {
        const { data: responseData } = await axios.post<GetAllBusinessDisplayUnitListResponse>(
            END_POINT.GET_ALL_BUSINESS_DISPLAY_UNIT_LIST,
            payLoad,
        );
        result.data = {
            totalCount: responseData.data.totalCount,
            businessDisplayUnitList: responseData.data.businessDisplayUnitList,
        };
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
};

export interface GetBusinessDisplayUnitRequestPayload {
    businessDisplayGroupId: string;
}

export interface GetBusinessDisplayUnitResult extends VriAPIResult {
    data?: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}

export interface GetBusinessDisplayUnitResponse extends VriAPIResponse {
    data: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}

export const getBusinessDisplayUnit = async (
    payLoad: GetBusinessDisplayUnitRequestPayload,
): Promise<GetBusinessDisplayUnitResult> => {
    const result = {} as GetBusinessDisplayUnitResult;
    try {
        const { data: responseData } = await axios.post<GetBusinessDisplayUnitResponse>(
            END_POINT.GET_BUSINESS_DISPLAY_UNIT,
            payLoad,
        );
        result.data = {
            totalCount: responseData.data.totalCount,
            businessDisplayUnitList: responseData.data.businessDisplayUnitList,
        };
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
};

export interface GetSearchBusinessWithBusinessGroupPayload {
    searchData: string;
    limit: number;
    offset: number;
}

export interface GetSearchBusinessWithBusinessGroupResponse extends VriAPIResponse {
    data: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}

export interface GetSearchBusinessWithBusinessGroupResult extends VriAPIResult {
    data: {
        totalCount: number;
        businessDisplayUnitList: BusinessDisplayUnit[];
    };
}
export const GetSearchBusinessWithBusinessGroup = async (
    payload: GetSearchBusinessWithBusinessGroupPayload,
): Promise<GetSearchBusinessWithBusinessGroupResult> => {
    const result = {} as GetSearchBusinessWithBusinessGroupResult;
    try {
        const { data: responseData } = await axios.post<GetSearchBusinessWithBusinessGroupResponse>(
            END_POINT.SEARCH_BUSINESS_WITH_BUSINESSGROUP,
            payload,
        );
        result.data = {
            totalCount: responseData.data.totalCount,
            businessDisplayUnitList: responseData.data.businessDisplayUnitList,
        };
    } catch (error) {
        result.error = getErrorMessage(error);
    }

    return result;
};
